import React, { Component } from 'react';
import { connect } from 'react-redux'

import { closeAnnoucement, fetchAnnouncement, loadPointOfSale } from '../../actions/pointOfSale';

import Announcement from 'ui-kit/src/components/Announcement/Announcement';

class StatefulAnnouncement extends Component {
  componentDidMount() {
    this.loadAnnoucement();
  }

  componentDidUpdate() {
    this.loadAnnoucement();
  }

  loadAnnoucement() {
    this.props.fetchAnnouncement();
  }

  render() {
    return (
      <Announcement
        closeCallback={this.props.closeCallback}
        data={this.props.announcement}
        moreCallback={this.props.moreCallback}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    announcement: state.pointOfSale.announcement
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeCallback: closeAnnoucement.bind(null, dispatch),
    fetchAnnouncement: fetchAnnouncement.bind(null, dispatch),
    moreCallback: loadPointOfSale.bind(null, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(StatefulAnnouncement);



// WEBPACK FOOTER //
// ./src/components/StatefulAnnouncement/StatefulAnnouncement.jsx